import Utility from '../../../util/utilityfunctions';
import {showChangeReasonModal} from '../../../actions/Document/fourFortyGlDocumentActions';
import DocHubClient from '../../../util/doc-hub-client';

export function uploadError(store, code, message, document) {
	const storeState = store.getState();
	store.dispatch({
		type: 'KRONOS_DOCUMENT_UPLOAD_COMPLETE',
		meta: {code, message, document},
		engagementId: storeState.engagementId
	});
}

export function uploadComplete(store, message) {
	const storeState = store.getState();

	// Get uploaded file data from the store
	let documentData;
	if (storeState.docHelperDocuments && storeState.docHelperDocuments) {
		documentData = storeState.docHelperDocuments[message.FileName + '_' + message.FileId];
	}

	// This happens only after uploading a file after editing it
	if ((!documentData || !documentData.isUserUpload) && message.FileVersion > 1) {
		if (storeState.fourFortyGlDocuments.documents) {
			const fourFortyDocumentData = storeState.fourFortyGlDocuments.documents.byId[message.FileId.toUpperCase()];

			const show440GLModal = Utility.isChangeReasonRequired(storeState.engagement, storeState.quickLink, fourFortyDocumentData);

			const documentConnectionId = fourFortyDocumentData?.connectionId;
			const currentConnectionId = DocHubClient.getConnectionId();

			// Document was uploaded within the current browser tab
			if (documentConnectionId === currentConnectionId) {
				store.dispatch(showChangeReasonModal(show440GLModal, message.FileId));
			}
		}
	}
	store.dispatch({
		type: 'KRONOS_DOCUMENT_UPLOAD_COMPLETE',
		meta: {message},
		engagementId: storeState.engagementId,
		modifiedDate: new Date(),
		lastModifiedFullName: `${storeState.userPreferences?.firstName || ''} ${storeState.userPreferences?.lastName || ''}`.trim()
	});
}

export function uploadProgress(store, message) {
	const storeState = store.getState();
	store.dispatch({
		type: 'KRONOS_DOCUMENT_UPLOAD_PROGRESS',
		meta: {message},
		engagementId: storeState.engagementId
	});
}
